/** Popup **/
const popup = () => {
  let lastScrollTop = 0;
  let st = window.pageYOffset || document.documentElement.scrollTop;
  st > lastScrollTop ? popout() : popin();
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile
};

/** Popout animation **/
const popout = () => {
  gsap.to('.js-popUp', {
    opacity: 0,
    yPercent: '100',
    ease: 'power2.out',
    duration: '0.5',
  });
};

/** Popin animation **/
const popin = () => {
  gsap.to('.js-popUp', {
    opacity: 1,
    yPercent: '0',
    ease: 'power1.out',
    duration: '0.5',
  });
};

/** Auto pop up on homepage only */
if (window.location.pathname === '/') {
  /** load pop up on page load ***/
  gsap.from('.js-popUp', {
    opacity: 0,
    yPercent: '100',
    ease: 'power2.out',
    duration: '0.5',
  });

  popup();
  window.addEventListener('scroll', popup, false);
} else {
  gsap.set('.js-popUp', { yPercent: 100 });
}
